import React, { useEffect, useContext } from "react";
import { CallAPI } from "services/API";
import { DeviceContext } from 'utils/Device/DeviceContext';
import TableWithContainer from "utils/Table/TableWithContainer";
import TooltipButton from "utils/TooltipButton/TooltipButton";
import { Grid } from "@material-ui/core";

export default function QuotesAndPremium(props) {
    const device = useContext(DeviceContext);
    const integer = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const percent = new Intl.NumberFormat('en-US', {
        style: 'percent',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    const currency = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [dataPremium, setDataPremium] = React.useState([]);
    const [loadingPremium, setLoadingPremium] = React.useState(false);

    const GetData = async () => {
        const response = await CallAPI("POST", "/Advanced/GetQuotes", {
            startDate: props.startDate,
            endDate: props.endDate,
            states: props.states,
            city: props.city,
            groupBy: props.groupBy
        });
        
        if (response) {
            const formattedResponse = response.map((row) => [
                row.groupBy,
                integer.format(row.totalQuotes),
                percent.format(row.overallBindPercentage / 100),
                integer.format(row.quick),
                integer.format(row.custom),
                integer.format(row.crc),
                integer.format(row.agency),
            ]);

            setData(formattedResponse);
        }

        setLoading(false);
    };

    const GetDataPremium = async () => {
        const response = await CallAPI("POST", "/Advanced/GetQuotePremium", {
            startDate: props.startDate,
            endDate: props.endDate,
            states: props.states,
            city: props.city,
            groupBy: props.groupBy
        });

        if (response) {
            const formattedResponse = response.map((row) => [
                row.groupBy,
                currency.format(row.totalPremQuoted.toFixed(0)),
                currency.format(row.overallAvgPrem.toFixed(0)),
                currency.format(row.quickAvgPrem.toFixed(0)),
                currency.format(row.customAvgPrem.toFixed(0)),
                currency.format(row.crcAvgPrem.toFixed(0)),
                currency.format(row.agencyAvgPrem.toFixed(0)),
            ]);

            setDataPremium(formattedResponse);
        }

        setLoadingPremium(false);
    };

    useEffect(() => {
        if (props.call === "true" || props.call === null) {
            GetDataPremium();
            setLoadingPremium(true);
            GetData();
            setLoading(true);
        }
    }, [props.call]);

    return (
        <Grid container>
            <Grid item lg={6} xs={12}>
                <TableWithContainer
                    title="QUOTES"
                    exportName="Quotes"
                    loading={loading}
                    rowsPerPage={32}
                    fixedColumns={1}
                    style={{
                        Title: { lineHeight: "1em", fontSize: device.isMobile ? "1.3em" : "2.5em" },
                        Table: {
                            Header: { minWidth: "120px" }
                        }
                    }}
                    headers={[[
                        props.groupBy, "Total Quotes",
                        {
                            text: (<>Overall Bind %<TooltipButton tooltipText={"Percentage of policies bound to-date, based on the specific quotes from each applicable time period."} /></>),
                            style: { padding: "0" }
                        },
                        "Quick", "Custom", "CRC", "Agency",
                    ]]}
                    rows={data.filter(x => x[0] !== "Total")}
                    footers={data.filter(x => x[0] === "Total")}
                />
            </Grid>
            <Grid item lg={6} xs={12}>
                <TableWithContainer
                    title="QUOTE PREMIUM"
                    exportName="Quote Premium"
                    loading={loadingPremium}
                    rowsPerPage={32}
                    fixedColumns={1}
                    style={{
                        Title: { lineHeight: "1em", fontSize: device.isMobile ? "1.3em" : "2.5em" },
                        Table: {
                            Header: { minWidth: "120px" },
                        }
                    }}
                    headers={[[props.groupBy, "Total Prem Quoted", "Overall Avg Prem", "Quick Avg Prem", "Custom Avg Prem", "CRC Avg Prem", "Agency Avg Prem",]]}
                    rows={dataPremium.filter(x => x[0] !== "Total")}
                    footers={dataPremium.filter(x => x[0] === "Total")}
                />
            </Grid>
        </Grid>
    );
}
